import {ref} from "vue";
// DEV_API toggle: true = dev (my.veridian.ro), false = production (api.telejurnal.com)
const DEV_API = process.env.VUE_APP_DEV_API === 'true'
const DEV_API_URL = process.env.VUE_APP_DEV_API_URL || 'https://my.veridian.ro:6677'
const PROD_API_URL = process.env.VUE_APP_PROD_API_URL || 'https://api.telejurnal.com'
const BASE_URL_PART1 = DEV_API ? DEV_API_URL : PROD_API_URL
const VERSION_URL='/v1'
const BASE_URL=BASE_URL_PART1+"/api"+VERSION_URL
console.log(`[url_config] DEV_API=${DEV_API}, API → ${BASE_URL_PART1}`)
const WS_URL="" //wss://server.rcharge.ro:9002"
const sandboxRedirectionUrl = ref( 'https://sandboxsecure.mobilpay.ro')
const secureRedirectionUrl = ref( 'https://secure.mobilpay.ro')
const FACEBOOK_APP_ID='590253342582282'
export {BASE_URL,sandboxRedirectionUrl, secureRedirectionUrl, WS_URL, FACEBOOK_APP_ID}
